import { Component, Inject, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogBoundryService } from "@secca/core/services/dialog-boundry.service";
import { DialogHelperUtilService } from "@secca/core/services/dialog-helper-util.service";
import { DialogMinimizableDirective } from "@secca/shared/directives/dialog-minimizable.directive";
import { MinimizableDialogType } from "@secca/shared/enums/minimizable-dialog-type-enum";
import { AdditionalInfo, IAdditionalInfo } from "@secca/shared/interfaces/additional-info";
import { IKeyboardEnabled } from "@secca/shared/interfaces/keyboard-enabled";
import { IMinimizable } from "@secca/shared/interfaces/minimizable";
import { PolicyLookupComponent } from "../policy-lookup/policy-lookup.component";
import { PolicyLookupDialogData } from "./policy-lookup-dialog-data.component";

@Component({
    selector: 'app-policy-lookup-dialog',
    templateUrl: './policy-lookup-dialog.component.html',
    styleUrls: ['./policy-lookup-dialog.component.scss'],
    standalone: false
})
  export class PolicyLookupDialogComponent implements IAdditionalInfo, IMinimizable, IKeyboardEnabled {
    @ViewChild(PolicyLookupComponent) wrappedInstance: PolicyLookupComponent;
    @ViewChild(DialogMinimizableDirective) minimizedDirective: DialogMinimizableDirective;

    data: PolicyLookupDialogData;

    constructor(private dialogRef: MatDialogRef<PolicyLookupDialogComponent>,
                @Inject(MAT_DIALOG_DATA) data: PolicyLookupDialogData,
                private dialogHelperUtilService: DialogHelperUtilService,
                public dialogBoundryService: DialogBoundryService) {

      this.data = data;
    }

    close() {
      this.dialogHelperUtilService.close(this.dialogRef, this.getAdditionalInfo()?.caseId);
    }

    keyboardClose(): void {
      this.wrappedInstance.close();
    }

    minimize() {
      this.minimizedDirective.minimize();
    }

    getMinimizeType(): MinimizableDialogType {
      return this.minimizedDirective.appDialogMinimizable;
    }

    getAdditionalInfo(): AdditionalInfo {

      return {
        caseId: +this.data.caseId,
        hoverTitle: this.data.caseNumber ? this.data.caseNumber : `CASE ID: ${this.data.caseId}`,
        hoverText: 'Policy lookup'
      };
    }

    get MinimizableDialogType() {
      return MinimizableDialogType;
    }
}
